import React, {useEffect} from 'react'
import ScrollAni from "../components/ScrollAni";

import intro_bg01_pc from "../assets/images/main/img_intro_flow01-pc.jpg";
import intro_bg02_pc from "../assets/images/main/img_intro_flow02-pc.jpg";
import intro_bg03_pc from "../assets/images/main/img_intro_flow03-pc.jpg";
import intro_bg04_pc from "../assets/images/main/img_intro_flow04-pc.jpg";
import intro_bg05_pc from "../assets/images/main/img_intro_flow05-pc.jpg";
import intro_bg06_pc from "../assets/images/main/img_intro_flow06-pc.jpg";
import intro_bg07_pc from "../assets/images/main/img_intro_flow07-pc.jpg";
import intro_bg08_pc from "../assets/images/main/img_intro_flow08-pc.jpg";
import intro_bg09_pc from "../assets/images/main/img_intro_flow09-pc.jpg";
import intro_bg10_pc from "../assets/images/main/img_intro_flow10-pc.jpg";
import intro_bg11_pc from "../assets/images/main/img_intro_flow11-pc.jpg";
import intro_bg12_pc from "../assets/images/main/img_intro_flow12-pc.jpg";
import intro_bg13_pc from "../assets/images/main/img_intro_flow13-pc.jpg";
import intro_bg14_pc from "../assets/images/main/img_intro_flow14-pc.jpg";
import intro_bg15_pc from "../assets/images/main/img_intro_flow15-pc.jpg";
import intro_bg16_pc from "../assets/images/main/img_intro_flow16-pc.jpg";
import intro_bg17_pc from "../assets/images/main/img_intro_flow17-pc.jpg";
import intro_bg18_pc from "../assets/images/main/img_intro_flow18-pc.jpg";
import intro_bg19_pc from "../assets/images/main/img_intro_flow19-pc.jpg";
import intro_bg20_pc from "../assets/images/main/img_intro_flow20-pc.jpg";
import intro_bg21_pc from "../assets/images/main/img_intro_flow21-pc.jpg";
import intro_bg22_pc from "../assets/images/main/img_intro_flow22-pc.jpg";
import intro_bg23_pc from "../assets/images/main/img_intro_flow23-pc.jpg";
import intro_bg24_pc from "../assets/images/main/img_intro_flow24-pc.jpg";
import intro_bg25_pc from "../assets/images/main/img_intro_flow25-pc.jpg";
import intro_bg26_pc from "../assets/images/main/img_intro_flow26-pc.jpg";
import intro_bg27_pc from "../assets/images/main/img_intro_flow27-pc.jpg";
import intro_bg28_pc from "../assets/images/main/img_intro_flow28-pc.jpg";
import intro_bg29_pc from "../assets/images/main/img_intro_flow29-pc.jpg";
import intro_bg30_pc from "../assets/images/main/img_intro_flow30-pc.jpg";
import intro_bg31_pc from "../assets/images/main/img_intro_flow31-pc.jpg";
import intro_bg32_pc from "../assets/images/main/img_intro_flow32-pc.jpg";
import intro_bg33_pc from "../assets/images/main/img_intro_flow33-pc.jpg";
import intro_bg34_pc from "../assets/images/main/img_intro_flow34-pc.jpg";
import intro_bg35_pc from "../assets/images/main/img_intro_flow35-pc.jpg";


const IntroRollingBg = () => {
  useEffect(() => {
    setTimeout(function(){
      document.querySelector('.intro').classList.add('active');
    },0);
  }, []);

  return (
    <section className="intro">
      <div className="bg-flow-list">
        <div className="bg-flow-rotate-box">
          <div className="bg-flow-align-box list01">
            <div className="bg-flow-ul-wrap">
              <ul className="bg-flow-ul-box">
                <li style={{ backgroundImage: `url(${intro_bg01_pc})` }} className="bg-flow-image"></li>
                <li style={{ backgroundImage: `url(${intro_bg02_pc})` }} className="bg-flow-image"></li>
                <li style={{ backgroundImage: `url(${intro_bg03_pc})` }} className="bg-flow-image"></li>
                <li style={{ backgroundImage: `url(${intro_bg04_pc})` }} className="bg-flow-image"></li>
              </ul>
              <ul className="bg-flow-ul-box">
                <li style={{ backgroundImage: `url(${intro_bg01_pc})` }} className="bg-flow-image"></li>
                <li style={{ backgroundImage: `url(${intro_bg02_pc})` }} className="bg-flow-image"></li>
                <li style={{ backgroundImage: `url(${intro_bg03_pc})` }} className="bg-flow-image"></li>
                <li style={{ backgroundImage: `url(${intro_bg04_pc})` }} className="bg-flow-image"></li>
              </ul>
            </div>
          </div>
          <div className="bg-flow-align-box list02">
            <div className="bg-flow-ul-wrap">
              <ul className="bg-flow-ul-box">
                <li style={{ backgroundImage: `url(${intro_bg05_pc})` }} className="bg-flow-image"></li>
                <li style={{ backgroundImage: `url(${intro_bg06_pc})` }} className="bg-flow-image"></li>
                <li style={{ backgroundImage: `url(${intro_bg07_pc})` }} className="bg-flow-image"></li>
                <li style={{ backgroundImage: `url(${intro_bg08_pc})` }} className="bg-flow-image"></li>
                <li style={{ backgroundImage: `url(${intro_bg09_pc})` }} className="bg-flow-image"></li>
              </ul>
              <ul className="bg-flow-ul-box">
                <li style={{ backgroundImage: `url(${intro_bg05_pc})` }} className="bg-flow-image"></li>
                <li style={{ backgroundImage: `url(${intro_bg06_pc})` }} className="bg-flow-image"></li>
                <li style={{ backgroundImage: `url(${intro_bg07_pc})` }} className="bg-flow-image"></li>
                <li style={{ backgroundImage: `url(${intro_bg08_pc})` }} className="bg-flow-image"></li>
                <li style={{ backgroundImage: `url(${intro_bg09_pc})` }} className="bg-flow-image"></li>
              </ul>
            </div>
          </div>
          <div className="bg-flow-align-box list03">
            <div className="bg-flow-ul-wrap">
              <ul className="bg-flow-ul-box">
                <li style={{ backgroundImage: `url(${intro_bg10_pc})` }} className="bg-flow-image"></li>
                <li style={{ backgroundImage: `url(${intro_bg11_pc})` }} className="bg-flow-image"></li>
                <li style={{ backgroundImage: `url(${intro_bg12_pc})` }} className="bg-flow-image"></li>
                <li style={{ backgroundImage: `url(${intro_bg13_pc})` }} className="bg-flow-image"></li>
                <li style={{ backgroundImage: `url(${intro_bg14_pc})` }} className="bg-flow-image"></li>
                <li style={{ backgroundImage: `url(${intro_bg15_pc})` }} className="bg-flow-image"></li>
              </ul>
              <ul className="bg-flow-ul-box">
                <li style={{ backgroundImage: `url(${intro_bg10_pc})` }} className="bg-flow-image"></li>
                <li style={{ backgroundImage: `url(${intro_bg11_pc})` }} className="bg-flow-image"></li>
                <li style={{ backgroundImage: `url(${intro_bg12_pc})` }} className="bg-flow-image"></li>
                <li style={{ backgroundImage: `url(${intro_bg13_pc})` }} className="bg-flow-image"></li>
                <li style={{ backgroundImage: `url(${intro_bg14_pc})` }} className="bg-flow-image"></li>
                <li style={{ backgroundImage: `url(${intro_bg15_pc})` }} className="bg-flow-image"></li>
              </ul>
            </div>
          </div>
          <div className="bg-flow-align-box list04">
            <div className="bg-flow-ul-wrap">
              <ul className="bg-flow-ul-box">
                <li style={{ backgroundImage: `url(${intro_bg16_pc})` }} className="bg-flow-image"></li>
                <li style={{ backgroundImage: `url(${intro_bg17_pc})` }} className="bg-flow-image"></li>
                <li style={{ backgroundImage: `url(${intro_bg18_pc})` }} className="bg-flow-image"></li>
                <li style={{ backgroundImage: `url(${intro_bg19_pc})` }} className="bg-flow-image"></li>
                <li style={{ backgroundImage: `url(${intro_bg20_pc})` }} className="bg-flow-image"></li>
              </ul>
              <ul className="bg-flow-ul-box">
                <li style={{ backgroundImage: `url(${intro_bg16_pc})` }} className="bg-flow-image"></li>
                <li style={{ backgroundImage: `url(${intro_bg17_pc})` }} className="bg-flow-image"></li>
                <li style={{ backgroundImage: `url(${intro_bg18_pc})` }} className="bg-flow-image"></li>
                <li style={{ backgroundImage: `url(${intro_bg19_pc})` }} className="bg-flow-image"></li>
                <li style={{ backgroundImage: `url(${intro_bg20_pc})` }} className="bg-flow-image"></li>
              </ul>
            </div>
          </div>
          <div className="bg-flow-align-box list05">
            <div className="bg-flow-ul-wrap">
              <ul className="bg-flow-ul-box">
                <li style={{ backgroundImage: `url(${intro_bg21_pc})` }} className="bg-flow-image"></li>
                <li style={{ backgroundImage: `url(${intro_bg22_pc})` }} className="bg-flow-image"></li>
                <li style={{ backgroundImage: `url(${intro_bg23_pc})` }} className="bg-flow-image"></li>
                <li style={{ backgroundImage: `url(${intro_bg24_pc})` }} className="bg-flow-image"></li>
                <li style={{ backgroundImage: `url(${intro_bg25_pc})` }} className="bg-flow-image"></li>
                <li style={{ backgroundImage: `url(${intro_bg26_pc})` }} className="bg-flow-image"></li>
              </ul>
              <ul className="bg-flow-ul-box">
                <li style={{ backgroundImage: `url(${intro_bg21_pc})` }} className="bg-flow-image"></li>
                <li style={{ backgroundImage: `url(${intro_bg22_pc})` }} className="bg-flow-image"></li>
                <li style={{ backgroundImage: `url(${intro_bg23_pc})` }} className="bg-flow-image"></li>
                <li style={{ backgroundImage: `url(${intro_bg24_pc})` }} className="bg-flow-image"></li>
                <li style={{ backgroundImage: `url(${intro_bg25_pc})` }} className="bg-flow-image"></li>
                <li style={{ backgroundImage: `url(${intro_bg26_pc})` }} className="bg-flow-image"></li>
              </ul>
            </div>
          </div>
          <div className="bg-flow-align-box list06">
            <div className="bg-flow-ul-wrap">
              <ul className="bg-flow-ul-box">
                <li style={{ backgroundImage: `url(${intro_bg27_pc})` }} className="bg-flow-image"></li>
                <li style={{ backgroundImage: `url(${intro_bg28_pc})` }} className="bg-flow-image"></li>
                <li style={{ backgroundImage: `url(${intro_bg29_pc})` }} className="bg-flow-image"></li>
                <li style={{ backgroundImage: `url(${intro_bg30_pc})` }} className="bg-flow-image"></li>
                <li style={{ backgroundImage: `url(${intro_bg31_pc})` }} className="bg-flow-image"></li>
              </ul>
              <ul className="bg-flow-ul-box">
                <li style={{ backgroundImage: `url(${intro_bg27_pc})` }} className="bg-flow-image"></li>
                <li style={{ backgroundImage: `url(${intro_bg28_pc})` }} className="bg-flow-image"></li>
                <li style={{ backgroundImage: `url(${intro_bg29_pc})` }} className="bg-flow-image"></li>
                <li style={{ backgroundImage: `url(${intro_bg30_pc})` }} className="bg-flow-image"></li>
                <li style={{ backgroundImage: `url(${intro_bg31_pc})` }} className="bg-flow-image"></li>
              </ul>
            </div>
          </div>
          <div className="bg-flow-align-box list07">
            <div className="bg-flow-ul-wrap">
              <ul className="bg-flow-ul-box">
                <li style={{ backgroundImage: `url(${intro_bg32_pc})` }} className="bg-flow-image"></li>
                <li style={{ backgroundImage: `url(${intro_bg33_pc})` }} className="bg-flow-image"></li>
                <li style={{ backgroundImage: `url(${intro_bg34_pc})` }} className="bg-flow-image"></li>
                <li style={{ backgroundImage: `url(${intro_bg35_pc})` }} className="bg-flow-image"></li>
              </ul>
              <ul className="bg-flow-ul-box">
                <li style={{ backgroundImage: `url(${intro_bg32_pc})` }} className="bg-flow-image"></li>
                <li style={{ backgroundImage: `url(${intro_bg33_pc})` }} className="bg-flow-image"></li>
                <li style={{ backgroundImage: `url(${intro_bg34_pc})` }} className="bg-flow-image"></li>
                <li style={{ backgroundImage: `url(${intro_bg35_pc})` }} className="bg-flow-image"></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="intro_text">
        <h2 className="intro_text-tit">
          새로운 시작을 위한 <strong>끌레,</strong><br/>
          나만의 <strong>해답</strong>을 찾는 여정
        </h2>
        <div className="intro_text-sub">
          <span>스타 법무법인</span>
          <span>대전분사무소</span>
        </div>
      </div>
      <ScrollAni />
    </section>
  )
}

export default IntroRollingBg